/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font } from '@chegg-ui/theme';
import { getBaseInputStyles } from '@chegg-ui/input';
import styled, { css } from 'styled-components';
export var FauxInputCombobox = styled.div.withConfig({
  componentId: "sc-1a1otbk-0"
})(["", ""], function (props) {
  return css(["", ""], getBaseInputStyles(props));
});
export var AutocompleteInput = styled.input.withConfig({
  componentId: "sc-1a1otbk-1"
})(["border:0;width:100%;height:100%;font-family:", ";font-size:", ";outline:0;background-color:transparent;text-overflow:ellipsis;padding:0;"], font.family["default"], font.size.px16);